module.exports = __webpack_public_path__ + "img/bg-work.96b41f07.jpg";